import React, { useState } from 'react';
import { Selection, Pedido } from '../../types';
import ClientSection from './components/ClientSection/ClientSection';
import './ClientView.scss';

interface ClientViewProps {
  selectionsByClient: {
    [clientIndex: number]: (Selection & { pedido: Pedido })[];
  };
  allowEdit: boolean;
  handleIncreaseQuantity: (pedido_id: number, selection_id: string) => void;
  handleDecreaseQuantity: (pedido_id: number, selection_id: string) => void;
  handleChangeOwner: (
    pedido_id: number,
    selection_id: string,
    new_client_index: number
  ) => void;
  handleDeleteSelection: (pedido_id: number, selection_id: string) => void;
  handleSplitSelection?: (pedido_id: number, selection_id: string) => void;
}

const ClientView: React.FC<ClientViewProps> = ({
  selectionsByClient,
  allowEdit,
  handleIncreaseQuantity,
  handleDecreaseQuantity,
  handleChangeOwner,
  handleDeleteSelection,
  handleSplitSelection,
}) => {
  const [numPeople] = useState(50);
  const [activeDropdownId, setActiveDropdownId] = useState<string | null>(null);
  // Close dropdown when clicking outside
  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Element;
      const isInsideDropdown = target.closest('.custom-dropdown-container') || 
                               target.closest('.portal-dropdown-menu');
      if (!isInsideDropdown) {
        setActiveDropdownId(null);
      }
    };

    if (activeDropdownId) {
      document.addEventListener('click', handleClickOutside);
      return () => document.removeEventListener('click', handleClickOutside);
    }
  }, [activeDropdownId]);

  const handleToggleDropdown = (dropdownId: string, event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    
    if (activeDropdownId === dropdownId) {
      setActiveDropdownId(null);
    } else {
      setActiveDropdownId(dropdownId);
    }
  };

  const handleSelectClient = (pedidoId: number, selectionId: string, clientIndex: number) => {
    handleChangeOwner(pedidoId, selectionId, clientIndex);
    setActiveDropdownId(null);
  };

  // Format client display with hashtags
  const formatClientLabel = (clientIndex: number) => {
    if (clientIndex === -1) return 'Grupo';
    return `#${clientIndex + 1}`;
  };

  // Grand total calculation moved to parent component if needed

  return (
    <div className="client-view">


      <div className="client-view__sections">
        {Object.keys(selectionsByClient)
          .map(Number)
          .sort((a, b) => a - b)
          .map((idx) => {
            const items = selectionsByClient[idx] || [];
            return (
              <ClientSection
                key={idx}
                clientIndex={idx}
                selections={items}
                allowEdit={allowEdit}
                activeDropdownId={activeDropdownId}
                onIncreaseQuantity={handleIncreaseQuantity}
                onDecreaseQuantity={handleDecreaseQuantity}
                onDeleteSelection={handleDeleteSelection}
                onSplitSelection={handleSplitSelection}
                onToggleDropdown={handleToggleDropdown}
                onSelectClient={handleSelectClient}
                numPeople={numPeople}
                formatClientLabel={formatClientLabel}
              />
            );
          })}
      </div>



    </div>
  );
};

export default ClientView;
